export default __webpack_public_path__ + "static/media/ahn-kwangja.37b5c460.png";